export default {
  remote: 'starter_kit_forms_mfe',
  name: 'aac-template',
  source: 'https://github.com/telus/starter-kit-forms-mfe/',
  urlMapping: {
    localhost: 'http://localhost:4321/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/882035351/starter-kit-forms-mfe/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/882035351/starter-kit-forms-mfe/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/882035351/starter-kit-forms-mfe/v1/mf2/mf-manifest.json',
  },
};
